const initialState = {
    responseProductList: {},
    responseProduct: {}
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };
    switch (action.type) {
        case "PRODUCT_NECESSITY_LIST_RESPONSE":
            newState.responseProductList = action.value
            break;
        case "PRODUCT_NECESSITY_RESPONSE":
            newState.responseProduct = action.value
            break;
        case "UPLOAD_IMAGE_BACKOFFICE_RESPONSE":
            newState.responseUploadImage = action.value
            break;
        default:
            return newState;
    }

    return newState;
};

export default reducer;